export const getPanelStyles = () => ({
  '@global': {
    '.side-panel-keyword-planner.panel-right .panel-content': {
      '& .panel-body': {
        width: 600,
        paddingLeft: 24,
        paddingRight: 24,
        display: 'flex',
        height: 'calc(100% - 56px)',
        overflow: 'hidden',
        marginBottom: 65,
      },
      '& .panel-header': {
        paddingLeft: 24,
      },
      '& .react-block-ui-none, .react-block-ui': {
        display: 'flex',
        height: '100%',
      },
    },
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
